import { render, staticRenderFns } from "./LbPlanSelect.vue?vue&type=template&id=6bbf96a5&scoped=true&"
import script from "./LbPlanSelect.vue?vue&type=script&lang=js&"
export * from "./LbPlanSelect.vue?vue&type=script&lang=js&"
import style0 from "./LbPlanSelect.vue?vue&type=style&index=0&id=6bbf96a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbf96a5",
  null
  
)

export default component.exports